var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M126.615 72.31l-7.034-21.647L105.64 7.76c-.716-2.206-3.84-2.206-4.556 0l-13.94 42.903H40.856L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664 1.385 72.31a4.792 4.792 0 0 0 1.74 5.358L64 121.894l60.874-44.227a4.793 4.793 0 0 0 1.74-5.357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M64 121.894l23.144-71.23H40.856L64 121.893z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M64 121.894l-23.144-71.23H8.42L64 121.893z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M8.42 50.663L1.384 72.31a4.79 4.79 0 0 0 1.74 5.357L64 121.894 8.42 50.664z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M8.42 50.663h32.436L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M64 121.894l23.144-71.23h32.437L64 121.893z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M119.58 50.663l7.035 21.647a4.79 4.79 0 0 1-1.74 5.357L64 121.894l55.58-71.23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M119.58 50.663H87.145l13.94-42.902c.717-2.206 3.84-2.206 4.557 0l13.94 42.903z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.9d0884b3585a737dd80a0736f8a81c1d.svg";
export { ForwardRef as ReactComponent };